export default "__VITE_ASSET__Ba3ZWB5W__"